<template>
  <div>
    <div>
      <div :class="$style.cookieAlertAi" v-if="showed">
        <div :class="$style.cookieAlertAiContent">
          <p>
            By&nbsp;clicking “Accept All Cookies”, you agree to&nbsp;the storing of&nbsp;cookies on&nbsp;your device
            to&nbsp;enhance site navigation, analyze site usage, and assist in&nbsp;our marketing efforts. Learn more
            in&nbsp;our
            <a target="_blank" href="/docs/privacy-policy">Privacy Policy</a>
          </p>
          <div :class="$style.cookieAlertAiButtons">
            <base-button @click="acceptAllCookie">Accept All Cookies</base-button>
            <base-button data-modal="#cookieAlertModalAi">Cookies Settings</base-button>
          </div>
        </div>
      </div>
    </div>
    <MountingPortal mountTo="#cookieSettingsPortal">
      <cookie-settings
        :cookieSettings="cookieSettings"
        @saveSettings="saveSettings"
        @acceptAllCookie="acceptAllCookie"
      />
    </MountingPortal>
  </div>
</template>

<script>
import 'huntkit/hunt-kit.css';
import { BaseButton } from 'huntkit';
import CookieSettings from './CookieSettings.vue';
import Cookies from 'js-cookie';
import { MountingPortal } from 'portal-vue';

export default {
  name: 'CookieAlert',
  components: {
    BaseButton,
    CookieSettings,
    MountingPortal,
  },
  data() {
    return {
      showed: false,
      cookieSettings: {
        analytics: false,
        marketing: false,
        preference: false,
        unclassified: false,
      },
    };
  },
  mounted() {
    let cookieSettings = Cookies.get('cookie-settings');

    if (cookieSettings) {
      this.cookieSettings = JSON.parse(cookieSettings);
    }

    this.showed = !cookieSettings;
  },
  methods: {
    saveSettings() {
      Cookies.set('cookie-settings', JSON.stringify(this.cookieSettings), { secure: true, expires: 365 });
      this.hideCookieAlert();
    },
    acceptAllCookie() {
      for (let key in this.cookieSettings) {
        this.cookieSettings[key] = true;
      }
      Cookies.set('cookie-settings', JSON.stringify(this.cookieSettings), { secure: true, expires: 365 });
      this.hideCookieAlert();
    },
    hideCookieAlert() {
      this.showed = false;
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.cookieAlertAi {
  position: fixed;
  z-index: 1001;
  bottom: 0;
  left: 0;
  width: calc(100% - #{vars.$scrollbarWidth});
  padding: 3rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(29, 29, 31, 0.9);
  animation: cookieAlertAnimation 0.5s ease forwards;
  will-change: transform, opacity, scroll-position;

  @include mixins.media(md) {
    padding: 5rem 0;
  }

  @include mixins.media(xl) {
    padding: 8rem 0;
  }

  &Content {
    padding: 0 3rem;
    margin: 0 auto;

    @include mixins.media(sm) {
      max-width: 43rem;
    }

    @include mixins.media(md) {
      max-width: 82rem;
    }

    @include mixins.media(xl) {
      max-width: 102rem;
    }

    p {
      @include mixins.font(1.6rem, 1.45);

      color: #fff;
      font-weight: vars.$fontWeightLight;

      @include mixins.media(xl) {
        @include mixins.font(2rem, 1.45);
      }

      a {
        color: inherit;
        text-decoration: underline;

        @include mixins.hover {
          &:hover {
            color: #ffb800;
          }
        }
      }
    }
  }

  &Buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 3rem;
    gap: 10px;

    @include mixins.media(xl) {
      gap: 15px;
    }

    button {
      @include mixins.font(1.6rem, 1.12);

      padding: 1.5rem 2rem;
      border-radius: 6px;
      height: unset;
      background: #fff;
      color: #1d1d1d;
      white-space: nowrap;

      @include mixins.media(sm, max) {
        flex: 1;
      }

      @include mixins.media(xl) {
        @include mixins.font(2rem, 1.1);

        padding: 1.6rem 4rem;
      }
    }
  }
}

@keyframes cookieAlertAnimation {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
